<!-- <button [id]="id" [type]="type"
    [ngClass]="{'bg-k-gray-disabled bg-none cursor-default' : isDisabled,'button-outline disabled' : outline,'icon-button':roundedIcon}"
    role="button" [disabled]="isDisabled" aria-pressed="false" (click)="clicked()" [style]="_style">
    <ng-content></ng-content>
</button> -->


<button [id]="id" [type]="type" [class]="buttonStyle + ' ' + size" [ngClass]="{'disabled' : isDisabled}" role="button"
    [disabled]="isDisabled" aria-pressed="false" (click)="clicked()" [style]="_style">
    <fa-icon *ngIf="faIcon && iconPosition==='left'" [icon]="faIcon" class="icon"></fa-icon>
    <img *ngIf="picPath" [class]="'icon ' + picClass" [src]="picPath" />
    <span *ngIf="label" class="label">{{label}}</span>
    <fa-icon *ngIf="faIcon && iconPosition==='right'" [icon]="faIcon" class="icon"></fa-icon>
</button>